// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { branch } from 'core/utils';
import { units } from 'client/styles';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';

/**
 * `Props` type.
 */

type Props = {
  children?: string | React$Element<*> | () => React$Element<*>,
  lead?: string,
  leadColor?: string,
  title: string,
  titleColor: string
};

/**
 * `Information` component.
 */

function Information(props: Props): React$Element<*> {
  const { children, lead, leadColor, title, titleColor } = props;

  return (
    <Row>
      <Col
        md={2}
        xs={10}
        xsOffset={1}
      >
        <Text.H2 color={titleColor}>
          {title}
        </Text.H2>
      </Col>

      <Col
        md={6}
        xs={10}
        xsOffset={1}
      >
        <Layout paddingTopMd={'11px'}>
          {branch(lead, () => (
            <Text.H4
              color={leadColor}
              marginBottom={units(0)}
              weight={300}
            >
              <RawHtml.span>
                {lead}
              </RawHtml.span>
            </Text.H4>
          ))}

          {children}
        </Layout>
      </Col>
    </Row>
  );
}

/**
 * Export `Information` component.
 */

export default Information;



// WEBPACK FOOTER //
// ../src/client/components/about/information.js